import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes } from '@/types';
import { generateUUID } from '@/tools/helpers';
import { getValueLanguageConent } from '@/tools/languageValue';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope Exhibitions. Pass an exhibitionID to
 * show all articles of belonging exhibition
 * @param {*} store
 * @param { id } exhibitionID
 * @params { { sortBy } } options sorty which tag (name, title, description) default title
 */
export default function ({ rootState, commit, dispatch }, { options = {} }) {
	const tours = options.exhibitionID
		? Object.values(rootState.tour.toursMap).filter((tour) => tour.exhibitionID === options.exhibitionID)
		: Object.values(rootState.tour.toursMap);

	const { sortBy } = Object.assign({ sortBy: 'title' }, options);

	const data = tours
		.filter((tour) => !tour.isVirtual)
		.map((tour) => {
			const languageContent = tour.languageContent.filter(
				(lc) => lc.languageISO === rootState.persistent.language
			)[0];
			languageContent.cover = tour.coverID
				? setUrlToDataSource(
						`../media-${getValueLanguageConent(tour.coverID.languageContent, 'source')}/512`,
						rootState.dataSourceURL
				  )
				: undefined;
			return {
				key: generateUUID(),
				id: tour.tourID,
				name: tour.name,
				class: 'data--' + tour.tourID,
				role: 'link',
				// active: `${rootState.visitedTourIDs.has(tour._id)}`, // not yet implemented
				url: '',
				click: () => {
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchTours,
						uiState: uiStates.hidden,
					});
					dispatch(actionTypes.tourStart, { tourID: tour._id });
				},
				...languageContent,
			};
		}) // eslint-disable-next-line
		.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : a[sortBy] < b[sortBy] ? -1 : 0));
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.tours,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchTours,
		uiState: uiStates.maximised,
	});
}
